import { Button } from '@cian/ui-kit/button';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import * as styles from './PaginationControls.css';
import { loadListingOffers } from '../../../common/actions/listingOffers';
import { ETestId } from '../../../common/constants/testId';
import { selectIsOffersLoading } from '../../../common/selectors/listingOffers';
import { selectHasMoreOffers } from '../../../common/selectors/listingOffers/selectHasMoreOffers';
import { TThunkDispatch } from '../../../common/types/redux';
import { trackListingShow } from '../../tracking';

export const PaginationControlsContainer = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const containerRef = React.useRef<HTMLElement | null>(null);
  const isLoading = useSelector(selectIsOffersLoading);
  const hasMoreOffers = useSelector(selectHasMoreOffers);

  React.useEffect(() => {
    containerRef.current = document.getElementById(ETestId.ListingBody);
  }, []);

  const onMoreButtonClick = () => {
    dispatch(loadListingOffers({ nextPage: true })).then(trackListingShow('all_objects_on_map'));
  };

  const onScrollToTopClick = () => {
    containerRef.current?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className={styles['buttons']}>
      <Button
        onClick={onMoreButtonClick}
        theme="stroke_primary"
        loading={isLoading}
        fullWidth
        disabled={!hasMoreOffers}
      >
        Показать еще
      </Button>
      <Button onClick={onScrollToTopClick} theme="stroke_secondary" fullWidth>
        Вернуться наверх
      </Button>
    </div>
  );
};
